import { render } from "./MagentoBanner.vue?vue&type=template&id=265314ee"
import script from "./MagentoBanner.vue?vue&type=script&lang=js"
export * from "./MagentoBanner.vue?vue&type=script&lang=js"

import "./MagentoBanner.vue?vue&type=style&index=0&id=265314ee&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__